import React, { useContext } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { sidebar } from "../../../styles/theme";
import { getDashboardRoutes } from "../../../config/pipelineConfig";
import { UserContext } from "../../../contexts/UserContext";
import Logo from "../../../assets/images/sidebar_logo.png";

const Sidebar = () => {
  const location = useLocation();
  const isActive = (path) => location.pathname.startsWith(path);
  const dashboardRoutes = getDashboardRoutes();
  const { user } = useContext(UserContext);

  // ✅ Hide Profile route if not logged in
  const filteredRoutes = dashboardRoutes.filter((route) => {
    if (route.path === "/profile" && !user) {
      return false;
    }
    return true;
  });

  return (
    <div
      style={sidebar.container}
    >
      {/* Logo */}
      <div style={{ ...sidebar.brand, display: 'flex', justifyContent: 'flex-start' }}>
        <img 
          src={Logo} 
          alt="PathoTrack Logo" 
          style={{ width: '250px', height: 'auto', marginLeft: '-40px' }} 
        />
      </div>

      {/* Divider line */}
      <hr
        style={sidebar.divider}
      />

      <Nav className="flex-column">
        {filteredRoutes.map((route, idx) => (
          <NavLink
            key={idx}
            to={route.path}
            className="nav-link"
            style={sidebar.navLink(isActive(route.path))}
          >
            <i className={route.icon} style={sidebar.icon} />
            {route.name}
          </NavLink>
        ))}
      </Nav>
    </div>
  );
};

export default Sidebar;